import { eventsRequest } from '../../utils/eventsRequest';
import { SESSION_KEY_USER_DATA } from '../../constants';
import { EventFormSubmissionStatus } from '../../types';

/**
 * Submits a completed event form to the backend (authenticated route).
 * POST /submissions with userId, templateId, eventId, eventUuid,
 * submittedForChilds, and submission data. The submission is recorded per
 * (formId, eventId, childId) so a child enrolled in multiple events that
 * share the same form template fills out the form once per event.
 * On success, the form is removed from the To Do list and badge count decreases.
 */
const submitEventForm = async (
  formId: number,
  submission: { data: Record<string, unknown> },
  eventUuid?: string,
  submittedForChilds?: number[],
  eventId?: number
): Promise<{ success: boolean; message?: string }> => {
  try {
    const userDataRaw = localStorage.getItem(SESSION_KEY_USER_DATA);
    const userData = userDataRaw ? (JSON.parse(userDataRaw) as { uid?: number }) : null;
    const userId = userData?.uid ?? null;

    const response = await eventsRequest<{ statusCode: number; isSuccess: boolean }>(
      '/submissions',
      'post',
      {
        userId,
        templateId: formId,
        eventId,
        eventUuid,
        submission: JSON.stringify(submission.data),
        status: EventFormSubmissionStatus.SUBMITTED,
        submittedForChilds: submittedForChilds ?? [],
      }
    );

    if (response.status === 200 || response.status === 201) {
      const body = response.data;
      if (body?.isSuccess) {
        return { success: true };
      }
    }

    return { success: false, message: 'Submit failed' };
  } catch (error) {
    console.error('❌ Error submitting event form:', error);
    return { success: false, message: 'Unable to submit form. Please try again.' };
  }
};

export default submitEventForm;
